module.exports = __webpack_public_path__ + "img/02d6491.jpg";